<template>
  <template v-if="info">
    <!-- Compact tag for list tables - details on hover -->
    <span
      v-if="variant === 'tag'"
      :title="summary"
      class="inline-flex items-center gap-1 w-fit mt-1 px-1.5 py-0.5 rounded-full text-[10px] font-medium bg-orange-100 text-orange-800 border border-orange-200 cursor-help whitespace-nowrap"
    >
      <span class="w-1.5 h-1.5 rounded-full bg-orange-500"></span>
      Updated {{ shortDate }}
    </span>

    <!-- Full banner for the tender details page -->
    <div
      v-else
      class="mt-3 rounded-lg border border-orange-200 bg-orange-50 dark:bg-orange-900/20 dark:border-orange-800 p-3 text-sm"
    >
      <p class="font-semibold text-orange-800 dark:text-orange-300">
        🔔 Updated from Excel on {{ fullDate }}
      </p>
      <p v-if="restoreText" class="mt-1 text-orange-800 dark:text-orange-300">
        {{ restoreText }}
      </p>
      <ul v-if="info.changes.length" class="mt-1 list-disc list-inside text-orange-700 dark:text-orange-200 space-y-0.5">
        <li v-for="change in info.changes" :key="change.field">{{ formatExcelChange(change) }}</li>
      </ul>
    </div>
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import {
  getExcelUpdate,
  getExcelUpdateSummary,
  formatExcelChange,
  formatExcelRestore,
  formatExcelUpdateDate,
} from '@/utils/excelUpdateUtils'

const props = withDefaults(defineProps<{
  tender?: { excelUpdateInfo?: string | null } | null
  variant?: 'tag' | 'banner'
}>(), {
  variant: 'tag',
})

const info = computed(() => getExcelUpdate(props.tender))
const summary = computed(() => (info.value ? getExcelUpdateSummary(info.value) : ''))
const restoreText = computed(() => (info.value ? formatExcelRestore(info.value) : null))
const fullDate = computed(() => (info.value ? formatExcelUpdateDate(info.value) : ''))
const shortDate = computed(() =>
  info.value
    ? new Date(info.value.updatedAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })
    : '',
)
</script>
